<script>
    import TextField from '@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte';
    import Button from '@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte';  
    import Switch from '@itslearning/prometheus/assets/inputs/Switch/v1/Switch.svelte';
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import Select from '@itslearning/prometheus/assets/inputs/Select/v1/Select.svelte';
    import Accordion from '@itslearning/prometheus/assets/Navigation/Accordion/v1/Accordion.svelte';
    import AccordionItem from '@itslearning/prometheus/assets/Navigation/Accordion/v1/AccordionItem.svelte';
    import {navigateToViewSurveyPage} from '../navigation';
    import {txt} from '../i18n/i18n';
    import {createSurveyAI, getSurvey, getAllQuestions} from '../api';
    import {survey, questions} from '../stores';
    import { Question } from '../models/Question';

    let anonymous = true;
    let openExtern = false;
    let description = '';
    let warningText = txt('Unknown_error');

    let errorFromApi = false;
    let isSaving = false;
    let inputError = false;
    let numberOfQuestions = "10";

    function handleAnonymous({checked}) {
		if(checked){
            openExtern = false;
        }
	}

    function handleExternAnonymous({checked}) {
		if(!checked){
            anonymous = true;
        }
	}

    async function save() {
        if (description.trim().length > 0) {
            try{
                if(isSaving){
                    return;
                }
                isSaving = true;
                let respondentType = 1;
                if(anonymous){
                    openExtern ? respondentType = 3 : respondentType = 2;
                }
                await createSurveyAI(description, numberOfQuestions, respondentType);
                let result = await getSurvey();
                survey.set(result);
                result = await getAllQuestions();
                questions.set(result.questions.map(q => new Question(q)));
                errorFromApi = false;
                navigateToViewSurveyPage();
            } catch {
                errorFromApi = true;
            }
            isSaving = false;
        }
        else{
            inputError = true;
        }
    }

    function resetError() {
        inputError = false;
    }
</script>
<div class="flow edit-survey">
    <Banner type="warning" text={warningText} close={txt('Close')}  visible="{errorFromApi}" />
    <div>
        {txt('Ask_our_AI_info_message')}
    </div>
    <Banner type="warning" text={txt('Personal_data_warning')} visible="{true}" closable={false}/>

    <TextField type="area" maxlength="255" rows="1" label={txt('The_survey_is_about')} hasError={inputError} errorMessage={txt('Empty_survey_input_message')} on:keyup={resetError} bind:value={description} />
    <Select label={txt('Number_of_questions')} bind:value={numberOfQuestions} >
        <option value="5">5</option>
        <option value="7">7</option>
        <option value="10">10</option>
        <option value="15">15</option>
    </Select>
    <fieldset class="flow">
        <legend>{txt('Survey_type')}</legend>
        <Switch label={txt('Anonymous_responses')} name="AnonymousRespondents" bind:checked={anonymous} on:click={(e) => handleAnonymous(e.detail)} />
        <Switch label={txt('External_survey')} name="OpenExtern" bind:checked={openExtern} on:click={(e) => handleExternAnonymous(e.detail)} />
    </fieldset>
</div>
<div class="flow__larger">
    <div class="footer-actions">
        <div class="footer-actions-left">
            <Button text={txt('Generate_survey')} htmlType="button" type="primary" large="true" on:click={save} loading={isSaving} />
        </div>
    </div>

    <Accordion>
        <AccordionItem title={txt('Tips_and_examples')}>
            <p>{txt('Tips_and_examples_info')}</p>
            <ul>
                <li>{txt('Homework_habits')}</li>
                <li>{txt('Student_satisfaction_cafeteria')}</li>
                <li>{txt('Evaluation_of_the_teaching')}</li>
            </ul>
        </AccordionItem>
        <AccordionItem title={txt('How_does_this_work')}>
            <p>{txt('How_does_this_work_info_part1')}</p>
            <br />
            <p>{txt('How_does_this_work_info_part2')}</p>
        </AccordionItem>
    </Accordion>

</div>
